export enum TreeContextDispatchActionType {
	SetTimeEntryRefs,
	SetActiveTaskRef,
	RemoveRef,
	AddRef,
}
